<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="profile-page">

        <!-- PROFILE HEADER -->
        <div class="profile-header">
            <div class="relative">
                <div class="cover-container rounded-t-lg">
                    <img :src="require(`@/assets/images/profile/user-uploads/${userCoverImg}`)" alt="user-profile-cover" class="responsive block">
                </div>
                <div class="profile-img-container pointer-events-none">
                    <div>
                        <vs-avatar v-if="activeUserImg.startsWith('http')" key="onlineImg" class="user-profile-img" :src="activeUserImg" size="85px" />
                        <vs-avatar v-else key="localImg" class="user-profile-img" :src="require(`@/assets/images/portrait/small/${activeUserImg}`)" size="85px" />
                    </div>

                </div>
            </div>
            <div class="flex items-center justify-end flex-wrap profile-header-nav p-6">

                <div class="block sm:hidden">
                    <feather-icon @click="isNavOpen = !isNavOpen" icon="AlignJustifyIcon" v-show="!isNavOpen" class="vx-navbar-toggler" />
                    <feather-icon icon="XIcon" v-show="isNavOpen" @click="isNavOpen = !isNavOpen" class="vx-navbar-toggler" />
                </div>

            </div>
            <!-- <vx-navbar> -->
            <!-- </vx-navbar> -->
        </div>

        <!-- COL AREA -->
        <div class="vx-row">
            <div class="vx-col w-full lg:w-1/1">
            <vx-card title="Validating multiple rules">

                <p>You can validate multiple rules using <code>|</code>. You can find more validation rules <a href="https://baianat.github.io/vee-validate/guide/rules.html" target="_blank" rel="nofollow">here</a></p>
                <div class="mt-5">
                    <form>
                        <div class="vx-row w-1/2">
                            <div class="vx-col w-full">
                                <vs-input v-validate="'required|alpha_dash'" placeholder="Your Username" name="username" v-model="username" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('username')">{{ errors.first('username') }}</span>
                            </div>

                            <div class="vx-col w-1/2">
                                <vs-input v-validate="'required|alpha'" placeholder="Your Nick" name="displayName" v-model="displayName" class="mt-5 w-full" />
                                <span class="text-danger text-sm"  v-show="errors.has('displayName')">{{ errors.first('displayName') }}</span>
                            </div>


                            <div class="vx-col w-1/2">
                                <vs-input v-validate="'required|email'" placeholder="Your Email" name="email" v-model="email" class="mt-5 w-full" />
                                <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                            </div>

                        </div>
                        <vs-button v-if="$acl.check('admin')" type="filled" @click.prevent="submitForm" class="mt-5 block">Submit</vs-button>
                    </form>
                </div>

            </vx-card>
            </div>
        </div>

    </div>


</template>

<script>

export default {
    data() {
        return {
            displayName: '',
            username: '',
            email: '',
            isNavOpen: false,
            userInfo: {

            },
            userCoverImg: 'cover.jpg',
            wasSidebarOpen: null,
        }
    },
    computed: {
        activeUserImg() {
            return JSON.parse(localStorage.getItem('userInfo')).photoURL || this.$store.state.AppActiveUser.img;
        },
    },
    methods: {
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    const payload = {
                        displayName : this.displayName,
                        username : this.username,
                        email : this.email
                    };
                    this.$store.dispatch('userProfile/EDIT_PROFILE', payload);
                } else {
                    // form have errors
                }
            })
        }
    },
    components: {

    },
    mounted() {
        this.userInfo = this.$store.state.AppActiveUser;
        this.wasSidebarOpen = this.$store.state.reduceButton;
        this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
    },
    beforeDestroy() {
        if (!this.wasSidebarOpen) this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/pages/profile.scss";
</style>
